
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import { type NestedPage, PageType } from '../../../services/fourwaves/models';
import WebsiteMobileNavigationLink from './WebsiteMobileNavigationLink.vue';
import Collapsible from '../../layout/Collapsible.vue';
import { v4 as uuid } from 'uuid';

@Component({
  components: {
    WebsiteMobileNavigationLink,
    Collapsible,
  },
})
export default class WebsiteMobileNavigationDropdown extends Vue {
  @Prop({ type: Object, required: true }) readonly page!: NestedPage;

  readonly PageType = PageType;

  uniqueId = uuid();
  isOpen = false;
}
